import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import Storage from "@/app/core/util/Storage";
import { DateToPast, DateTranslateSimple } from "@/app/core/util/DateTranslater";
import { NotificationController } from "@/app/core/base/controllers/NotificationController";
import DeliveryModal from "../../main-components/delivery/DeliveryModal";

export default function Notifications() {
  const userData = Storage.getUserData();
  const [showModal, setShowModal] = useState(false);
  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);

  useEffect(() => {
    loadNotifications()
  }, [])

  function loadNotifications() {
    NotificationController.List(res => setData(res.filter(x => x.seen == false)));
  }

  function seeNotification(item) {
    if (item.data && item.data.length > 0) {
      setSelected(item.data[0].value);
      setShowModal(true);
    }
    NotificationController.Update({ ...item, seen: true }, res => {
      loadNotifications()
    })
  }

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle variant="light" className="btn btn-success text-warning">
          {data && data.length > 0 ? <span>{data.length}</span> : ""} <i className="far fa-bell ml-1" />
        </Dropdown.Toggle>
        <Dropdown.Menu>
          {data &&
            data.map((item, idx) => {
              if (idx > 10) return;
              if (item.seen != true) {

                return (
                  <Dropdown.Item
                    eventKey={item.id}
                    id={item.id}
                    key={item.id}
                    onClick={() => {
                      seeNotification(item);
                    }}
                  >
                    <div className="text-dark media py-2" href="#">
                      <div className="mx-3">
                        {item && item.imageUrl ?
                          <img src={item.imageUrl} style={{ height: 45 }} /> :
                          <i className="fa fa-tasks text-info" />
                        }
                      </div>
                      <div className="media-body font-size-sm pr-2">
                        <div className="font-w600">
                          {item.title}
                        </div>
                        <div className="text-muted font-italic">
                          {item.body}
                          {DateTranslateSimple(item.createdAt)} - (
                          {DateToPast(item.createdAt)})
                        </div>
                      </div>
                    </div>
                  </Dropdown.Item>
                );
              }
            })}

          {/* <Dropdown.Item
            className="p-2 border-top"
            onClick={() => {
              if (
                window.confirm("Tem certeza de que deseja marcar todas como lidas?")
              ) {
                markAsRead();
              }
            }}
          >
            <i className="si si-eye mr-1" /> Marcar todas como lidos
          </Dropdown.Item>
          <Dropdown.Item
            className="p-2 border-top"
            onClick={() => setShowCentralModal(true)}
          >
            <i className="si si-list mr-1" /> Central de notificações
          </Dropdown.Item> */}
        </Dropdown.Menu>
      </Dropdown>

      <DeliveryModal
        deliveryId={selected && selected}
        show={showModal}
        onHide={() => setShowModal(!showModal) | setSelected(null)}
      />
    </>
  );
}
